<template>
  <div class="reset-password-container">
    <!-- Token 無效時顯示錯誤訊息 -->
    <div v-if="isTokenValid === false" class="error-message">
      <p>密碼重置連結已過期或無效。</p>
    </div>

    <!-- Token 有效時顯示重置密碼表單 -->
    <div v-else-if="isTokenValid === true">
      <!-- 重置密碼的標題 -->
      <h1 class="reset-password-title">重置密碼</h1>

      <!-- Email 顯示區域 -->
      <div class="email-input-container">
        <label for="email">電子郵件</label>
        <input type="email" id="email" v-model="email" readonly />
      </div>

      <!-- 新密碼輸入區域 -->
      <div class="password-input-container">
        <label for="new-password">請輸入新密碼</label>
        <input
          type="password"
          id="new-password"
          v-model="newPassword"
          placeholder="輸入新密碼"
        />
      </div>

      <!-- 確認新密碼輸入區域 -->
      <div class="password-input-container">
        <label for="confirm-password">確認新密碼</label>
        <input
          type="password"
          id="confirm-password"
          v-model="confirmPassword"
          placeholder="再次輸入新密碼"
        />
      </div>

      <!-- 送出按鈕 -->
      <button class="submit-button" @click="handleSubmit">重置密碼</button>

      <!-- 成功提示訊息 -->
      <p v-if="successMessage" class="success-message">{{ successMessage }}</p>

      <!-- 錯誤提示訊息 -->
      <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
    </div>
  </div>
</template>

<script>
import ResetPage from "@/assets/js/reset.js";

export default {
  name: "ResetPage",
  mixins: [ResetPage], // 混入邏輯
};
</script>

<style src="@/assets/css/reset.css" scoped></style>
